import { render, staticRenderFns } from "./WordCategoriesList.vue?vue&type=template&id=276a4c61"
import script from "./WordCategoriesList.vue?vue&type=script&lang=js"
export * from "./WordCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports